import { DEPLOY_USER_POOL_KEYS } from '../../../../stacks/types/auth';

const prefixes = {
  common: 'VITE_REACT_APP',
};

const getEnv = (key: string, prefix: string): string | undefined => {
  return import.meta.env[`${prefix}_${key}`];
};

export const environments = {
  REACT_APP_DEPLOY_STAGE: import.meta.env.VITE_REACT_APP_DEPLOY_STAGE as string,
  REACT_APP_BASE_URL: import.meta.env.VITE_REACT_APP_BASE_URL as string,
  REACT_APP_AUTH_API: import.meta.env.VITE_REACT_APP_AUTH_API as string,
  REACT_APP_CLIENT_ID: import.meta.env.VITE_REACT_APP_CLIENT_ID as string,
  REACT_APP_ORG_V2: import.meta.env.VITE_REACT_APP_ORG_V2 as string,
  REACT_APP_ORG_V2_INVITE_REDEEM_DRIVER: import.meta.env.VITE_REACT_APP_ORG_V2_INVITE_REDEEM_DRIVER_API_PATH as string,
  REACT_APP_DEPLOY_USER_POOL_ID: getEnv(DEPLOY_USER_POOL_KEYS.POOL_ID, prefixes.common) as string,
  REACT_APP_DEPLOY_USER_POOL_WEB_CLIENT_ID: getEnv(DEPLOY_USER_POOL_KEYS.WEB_CLIENT_ID, prefixes.common) as string,
  REACT_APP_DEPLOY_USER_POOL_MOBILE_CLIENT_ID: getEnv(DEPLOY_USER_POOL_KEYS.MOBILE_CLIENT_ID, prefixes.common) as string,
  SERVICE_URL: 'web-app',
  MIXPANEL_PROJECT_TOKEN: import.meta.env.VITE_REACT_APP_MIXPANEL_TOKEN as string || 'a050ea07267198914d4c787a4087b1ac',
  BUGFENDER_APP_KEY: import.meta.env.VITE_REACT_APP_BUGFENDER_KEY as string || 'MoiQQmkqlOMDmYQcRcPGZ2o3BYAVnlwK',
  DRIVER_INVITE_ROUTE: import.meta.env.VITE_REACT_APP_DRIVER_INVITE_ROUTE as string,
};
